/**
 * Resolve provider API keys across browser (Vite) and server runtimes.
 *
 * Browser path:
 *   - prefers `import.meta.env.VITE_<NAME>_API_KEY`
 *
 * Server path:
 *   - prefers `process.env.<NAME>_API_KEY`
 *   - falls back to `process.env.VITE_<NAME>_API_KEY` for legacy envs
 */
export function getProviderKey(name: string): string | undefined {
  const normalized = name.trim().toUpperCase();
  if (!normalized) return undefined;
  const serverName = `${normalized}_API_KEY`;
  const viteName = `VITE_${normalized}_API_KEY`;

  try {
    if (typeof import.meta !== 'undefined' && (import.meta as { env?: Record<string, unknown> }).env) {
      const env = (import.meta as { env: Record<string, unknown> }).env;
      const fromVite = env[viteName];
      if (typeof fromVite === 'string' && fromVite.trim().length > 0) {
        return fromVite.trim();
      }
    }
  } catch {
    // ignore non-Vite runtimes
  }

  if (typeof process !== 'undefined' && process.env) {
    const fromServer = process.env[serverName];
    if (typeof fromServer === 'string' && fromServer.trim().length > 0) {
      return fromServer.trim();
    }
    const fromLegacyVite = process.env[viteName];
    if (typeof fromLegacyVite === 'string' && fromLegacyVite.trim().length > 0) {
      return fromLegacyVite.trim();
    }
  }
  return undefined;
}
